import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  Badge,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";

function ListadoPagosProveedores() {
  const { user } = useContext(AuthContext);
  const URL_PAGOS_PROVEEDORES = process.env.REACT_APP_URL_PAGOS_PROVEEDORES;
  const URL_ORDENES_COMPRA_CAT = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ANTICIPOS_PROVEEDORES = process.env.REACT_APP_URL_ANTICIPOS_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);

  let endDate   = moment(hoy).format("YYYY-MM-DD");
  let startDate   = moment(inicio).format("YYYY-MM-DD");


  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedValidado, setSelectedValidado] = useState("");
  const [selectedEstado, setSelectedEstado] = useState("");
  const [selectedConcepto, setSelectedConcepto] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  // Catalogo de conceptos (para el modal de edicion)
  const [conceptosCat, setConceptosCat] = useState([]);
  const URL_CONCEPTOS_PAGO = process.env.REACT_APP_URL_CONCEPTOS_PAGO;

  // Modal de edicion de pago
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [fechaEdit, setFechaEdit] = useState("");
  const [conceptoEdit, setConceptoEdit] = useState("");
  const [montoEdit, setMontoEdit] = useState(0);
  const [tcEdit, setTcEdit] = useState(1);
  const [obsEdit, setObsEdit] = useState("NA");
  const [esRefEdit, setEsRefEdit] = useState(false);

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{
    axios
      .get(`${URL_PAGOS_PROVEEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPagos = response.data;
        // Array para pagination
        let arrayTabla = allPagos
          .filter((a) => a.is_active !== "No") // ocultar cancelados
          .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idPagoProveedor,
              fecha: a.fecha,
              proveedores: a.proveedores?.[0]?.nombre_comercial || "",
              idProveedores: a.proveedores?.[0]?._id || "",
              odc: a.ordenesCompra?.idOrdenCompra
                ? `OC ${a.ordenesCompra.idOrdenCompra}`
                : "",
              embarque: a.embarques?.idEmbarques
                ? `EMB #${a.embarques.idEmbarques}`
                : "",
              concepto: a.conceptoNombre || a.conceptosPago?.concepto || "",
              idConcepto: a.conceptosPago?._id || "",
              montoUSD: a.montoUSD || 0,
              tipoCambio: a.tipoCambio || 1,
              totalMXN: a.totalMXN || 0,
              observaciones: a.observaciones || "NA",
              validado: a.validado || "No",
              estado: a.estado || "Simulado",
              archivos: a.archivos || [],
              ordenesCompraAplicadas: a.ordenesCompraAplicadas || [],
              dineroRecibido: a.dineroRecibido || "No",
              fechaDineroRecibido: a.fechaDineroRecibido || "",
              dineroRecibidoPor: a.dineroRecibidoPor || "",
              esReferencia: false,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        // Anticipos como REFERENCIA (su registro real vive en el módulo de Anticipos)
        axios
          .get(
            `${URL_ANTICIPOS_PROVEEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((resAnt) => {
            const anticiposRef = (resAnt.data || [])
              .filter((a) => a.is_active === "Si" && Number(a.importe) > 0)
              .map((a) => ({
                _id: a._id,
                numero: `A-${a.idAnticipoProveedores}`,
                fecha: a.fecha,
                proveedores: a.proveedores?.[0]?.nombre_comercial || "",
                idProveedores: a.proveedores?.[0]?._id || "",
                odc: a.ordenesCompra?.[0]?.idOrdenCompra
                  ? `OC ${a.ordenesCompra[0].idOrdenCompra}`
                  : "",
                embarque: "",
                concepto: "ANTICIPO",
                montoUSD: a.importe || 0,
                tipoCambio: a.tipoCambio || 1,
                totalMXN:
                  a.montoPesos || (a.importe || 0) * (a.tipoCambio || 1),
                validado: a.validado || "No",
                estado: "Pagado", // los anticipos ya afectan al crearse
                dineroRecibido: a.dineroRecibido || "No",
                fechaDineroRecibido: a.fechaDineroRecibido || "",
                esReferencia: true,
              }));
            // Orden inicial por fecha (más reciente primero)
            const combinado = [...arrayTabla, ...anticiposRef].sort((a, b) =>
              (a.fecha || "") < (b.fecha || "") ? 1 : -1
            );
            setComments(combinado);
          })
          .catch(() => {
            // Si falla el fetch de anticipos, al menos muestra los pagos (por fecha)
            setComments(
              [...arrayTabla].sort((a, b) =>
                (a.fecha || "") < (b.fecha || "") ? 1 : -1
              )
            );
          });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_PAGO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setConceptosCat(
          (response.data || []).filter((c) => c.is_active === "Si")
        );
      })
      .catch((err) => {
        console.log(err);
      });

  }, [ selectedFechaInicio, selectedFechaFin]);


  function PDFTabla() {
    let TotalUSD= 0
    let TotalMXN= 0
    const data = comments
    .filter(
      (comment) =>
        comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
        comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
        comment.odc.toLowerCase().includes(search.toLowerCase()) ||
        comment.numero.toString().includes(search)
    )
    .sort((a, b) => (a.numero > b.numero ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        TotalUSD = TotalUSD + (Number(a.montoUSD) || 0)
        TotalMXN = TotalMXN + (Number(a.totalMXN) || 0)
        return [
          a.numero,
          a.fecha,
          a.proveedores,
          a.odc,
          a.embarque,
          a.concepto,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.montoUSD),
          Number(a.tipoCambio).toFixed(2),
          new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN", maximumFractionDigits: 2}).format(a.totalMXN),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Listado Pagos`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Proveedor",
          "ODC",
          "Embarque",
          "Concepto",
          "Monto USD",
          "TC",
          "Total MXN",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalUSD),
          "",
          new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN", maximumFractionDigits: 2}).format(TotalMXN)
        ]
      ]
    });
    doc.save(`Pagos.pdf`);
  }

  function excel() {
    const dataExcel = comments
    .filter(
      (comment) =>
        comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
        comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
        comment.odc.toLowerCase().includes(search.toLowerCase()) ||
        comment.numero.toString().includes(search)
    )
    .sort((a, b) => (a.numero > b.numero ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Proveedor: a.proveedores,
          ODC: a.odc,
          Embarque: a.embarque,
          Concepto: a.concepto,
          MontoUSD: a.montoUSD,
          TC: a.tipoCambio,
          TotalMXN: a.totalMXN,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoPagos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoPagos",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Proveedor",
          "ODC",
          "Embarque",
          "Concepto",
          "MontoUSD",
          "TC",
          "TotalMXN",
          ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Proveedor",
          "ODC",
          "Embarque",
          "Concepto",
          "Monto USD",
          "TC",
          "Total MXN",
          ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let TotalUSD= 0
    let TotalMXN= 0
    const data = comments
    .filter(
      (comment) =>
        comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
        comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
        comment.odc.toLowerCase().includes(search.toLowerCase()) ||
        comment.numero.toString().includes(search)
    )
    .sort((a, b) => (a.numero > b.numero ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        TotalUSD = TotalUSD + (Number(a.montoUSD) || 0)
        TotalMXN = TotalMXN + (Number(a.totalMXN) || 0)
        return [
          a.numero,
          a.fecha,
          a.proveedores,
          a.odc,
          a.embarque,
          a.concepto,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.montoUSD),
          Number(a.tipoCambio).toFixed(2),
          new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN", maximumFractionDigits: 2}).format(a.totalMXN),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Listado Pagos`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Proveedor",
          "ODC",
          "Embarque",
          "Concepto",
          "Monto USD",
          "TC",
          "Total MXN",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalUSD),
          "",
          new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN", maximumFractionDigits: 2}).format(TotalMXN)
        ]
      ]
    });

    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Pagos",
          email: mailTo,
          fileName: "ListadoPagos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Pagos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }




  // Un comprobante puede cubrir varias OC (acuerdo del 16 OCT)
  const [modalOrdenes, setModalOrdenes] = useState(false);
  const toggleOrdenes = () => setModalOrdenes(!modalOrdenes);
  const [pagoOrdenes, setPagoOrdenes] = useState({});
  const [repartoOC, setRepartoOC] = useState([]);
  const [catalogoOC, setCatalogoOC] = useState([]);

  function abreOrdenes(a) {
    setPagoOrdenes(a);
    setRepartoOC(
      (a.ordenesCompraAplicadas || []).map((x) => ({
        ordenesCompra: x.ordenesCompra?._id || x.ordenesCompra || "",
        numero: x.numero || "",
        monto: x.monto || 0,
        observaciones: x.observaciones || "",
      }))
    );
    axios
      .get(URL_ORDENES_COMPRA_CAT, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const propias = (res.data || []).filter(
          (o) =>
            o.is_active === "Si" &&
            (!a.idProveedores ||
              String(o.proveedores?.[0]?._id || o.proveedores?._id || "") === String(a.idProveedores))
        );
        setCatalogoOC(propias);
      })
      .catch(() => setCatalogoOC([]));
    toggleOrdenes();
  }

  const sumaReparto = repartoOC.reduce((t, x) => t + (Number(x.monto) || 0), 0);

  function guardaReparto() {
    const limpio = repartoOC.filter((x) => x.ordenesCompra);
    if (sumaReparto > Number(pagoOrdenes.montoUSD || 0) + 0.01) {
      Swal.fire({
        icon: "error",
        title: "El reparto se pasa del pago",
        text: `Suma ${sumaReparto.toFixed(2)} y el pago es de ${Number(pagoOrdenes.montoUSD || 0).toFixed(2)}`,
      });
      return;
    }
    axios
      .patch(
        `${URL_PAGOS_PROVEEDORES}AplicaOrdenes/${pagoOrdenes._id}`,
        { ordenesCompraAplicadas: limpio },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then((res) => {
        setComments((anteriores) =>
          anteriores.map((x) =>
            x._id === pagoOrdenes._id
              ? { ...x, ordenesCompraAplicadas: res.data?.ordenesCompraAplicadas || [] }
              : x
          )
        );
        toggleOrdenes();
        Swal.fire({ icon: "success", title: "Reparto guardado" });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "No se pudo guardar",
          footer: `${error.response?.data || ""}`,
        });
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Proveedor", field: "proveedores", sortable: true },
    { name: "ODC", field: "odc", sortable: true },
    { name: "Embarque", field: "embarque", sortable: true },
    { name: "Concepto", field: "concepto", sortable: true },
    { name: "Monto USD", field: "montoUSD", sortable: true },
    { name: "TC", field: "tipoCambio", sortable: true },
    { name: "Total MXN", field: "totalMXN", sortable: true },
    { name: "Estado", field: "estado", sortable: true },
    { name: "Validado", field: "validado", sortable: true },
    { name: "Comprobante", field: "comprobante", sortable: false },
    { name: "Dinero recibido", field: "dineroRecibido", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
          comment.odc.toLowerCase().includes(search.toLowerCase()) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }

    if (selectedConcepto) {
      computedComments = computedComments.filter(
        (e) => e.concepto === selectedConcepto
      );
    }
    if (selectedValidado) {
      computedComments = computedComments.filter(
        (e) => e.validado === selectedValidado
      );
    }
    if (selectedEstado) {
      computedComments = computedComments.filter(
        (e) => e.estado === selectedEstado
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "montoUSD" &&
      sorting.field != "numero" &&
      sorting.field != "tipoCambio" &&
      sorting.field != "totalMXN"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "montoUSD" ||
        sorting.field == "numero" ||
        sorting.field == "tipoCambio" ||
        sorting.field == "totalMXN")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "montoUSD" ||
        sorting.field == "numero" ||
        sorting.field == "tipoCambio" ||
        sorting.field == "totalMXN")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedProveedor,
    selectedValidado,
    selectedEstado,
    selectedConcepto,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  function validarPago(id, numeroPago, proveedor, esReferencia) {
    const URL_BASE = esReferencia
      ? URL_ANTICIPOS_PROVEEDORES
      : URL_PAGOS_PROVEEDORES;
    Swal.fire({
      title: esReferencia ? "¿Validar este anticipo?" : "¿Validar este pago?",
      text: `${numeroPago} - ${proveedor}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, validar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_BASE}Validar/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Validar Pago",
                detalle: `${numeroPago} - ${proveedor}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            // Actualiza el estado local SIN refrescar la pagina
            setComments((prev) =>
              prev.map((c) => (c._id === id ? { ...c, validado: "Si" } : c))
            );
            Swal.fire("¡Listo!", "Pago validado", "success");
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error?.response?.data || ""}`,
            });
            console.log(error);
          });
      }
    });
  }

  // Paso 07 del flujo: B2B confirma que el proveedor ya recibio el dinero
  function confirmaDineroRecibido(a) {
    if (a.esReferencia) {
      Swal.fire({ icon: "info", title: "La recepcion se confirma en el modulo de Anticipos" });
      return;
    }
    const confirmar = a.dineroRecibido !== "Si";
    Swal.fire({
      title: confirmar ? "Confirmar recepcion del dinero?" : "Quitar la confirmacion?",
      text: confirmar
        ? `Pago ${a.numero} de ${a.proveedores}: el proveedor confirmo que recibio el dinero`
        : `Pago ${a.numero} de ${a.proveedores}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmar ? "Si, lo recibio" : "Si, quitar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${URL_PAGOS_PROVEEDORES}DineroRecibido/${a._id}`,
          {
            dineroRecibido: confirmar ? "Si" : "No",
            confirma: `${user.nombre} ${user.apellido}`,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((res) => {
          setComments((anteriores) =>
            anteriores.map((x) =>
              x._id === a._id
                ? {
                    ...x,
                    dineroRecibido: res.data?.dineroRecibido || "No",
                    fechaDineroRecibido: res.data?.fechaDineroRecibido || "",
                    dineroRecibidoPor: res.data?.dineroRecibidoPor || "",
                  }
                : x
            )
          );
          Swal.fire({
            icon: "success",
            title: confirmar ? "Recepcion confirmada" : "Se quito la confirmacion",
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "No se pudo guardar",
            footer: `${error.response?.data || ""}`,
          });
          console.log(error);
        });
    });
  }

  function desvalidarPago(id, numeroPago, proveedor, esReferencia) {
    const URL_BASE = esReferencia
      ? URL_ANTICIPOS_PROVEEDORES
      : URL_PAGOS_PROVEEDORES;
    Swal.fire({
      title: "¿Quitar la validación?",
      text: `${numeroPago} - ${proveedor}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, quitar validación",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_BASE}Desvalidar/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Quitar Validacion Pago",
                detalle: `${numeroPago} - ${proveedor}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            // Actualiza el estado local SIN refrescar la pagina
            setComments((prev) =>
              prev.map((c) => (c._id === id ? { ...c, validado: "No" } : c))
            );
            Swal.fire("¡Listo!", "Validación removida", "success");
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error?.response?.data || ""}`,
            });
            console.log(error);
          });
      }
    });
  }

  // Marcar un pago simulado como PAGADO (aplica el efecto en saldos)
  function marcarPagado(id, numeroPago, proveedor) {
    Swal.fire({
      title: "¿Marcar como PAGADO?",
      text: `${numeroPago} - ${proveedor}. Se aplicará el efecto en los saldos.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, marcar pagado",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PAGOS_PROVEEDORES}MarcarPagado/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Marcar Pago Pagado",
                detalle: `${numeroPago} - ${proveedor}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            setComments((prev) =>
              prev.map((c) => (c._id === id ? { ...c, estado: "Pagado" } : c))
            );
            Swal.fire("¡Listo!", "Pago marcado como pagado", "success");
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error?.response?.data || ""}`,
            });
            console.log(error);
          });
      }
    });
  }

  // Regresar un pago a SIMULADO (revierte el efecto en saldos)
  function marcarSimulado(id, numeroPago, proveedor) {
    Swal.fire({
      title: "¿Regresar a SIMULADO?",
      text: `${numeroPago} - ${proveedor}. Se revertirá el efecto en los saldos.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, regresar a simulado",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PAGOS_PROVEEDORES}MarcarSimulado/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Marcar Pago Simulado",
                detalle: `${numeroPago} - ${proveedor}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            setComments((prev) =>
              prev.map((c) => (c._id === id ? { ...c, estado: "Simulado" } : c))
            );
            Swal.fire("¡Listo!", "Pago regresado a simulado", "success");
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error?.response?.data || ""}`,
            });
            console.log(error);
          });
      }
    });
  }

  function abrirEditar(a) {
    setIdEdit(a._id);
    setNumeroEdit(a.numero);
    setFechaEdit(a.fecha);
    setConceptoEdit(a.idConcepto || "");
    setMontoEdit(a.montoUSD);
    setTcEdit(a.tipoCambio);
    setObsEdit(a.observaciones || "NA");
    setEsRefEdit(!!a.esReferencia);
    toggleEdit();
  }

  function guardarEdit(event) {
    event.preventDefault();
    const monto = Number(montoEdit) || 0;
    const tc = Number(tcEdit) || 1;
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    // Anticipo -> endpoint de anticipos (valores absolutos); Pago -> endpoint de pagos
    const request = esRefEdit
      ? axios.patch(
          `${URL_ANTICIPOS_PROVEEDORES}EditCompleto/${idEdit}`,
          {
            fecha: fechaEdit,
            importe: monto,
            tipoCambio: tc,
            observaciones: obsEdit || "NA",
          },
          { headers }
        )
      : axios.patch(
          `${URL_PAGOS_PROVEEDORES}/${idEdit}`,
          {
            fecha: fechaEdit,
            conceptosPago: conceptoEdit || null,
            montoUSD: monto,
            tipoCambio: tc,
            totalMXN: monto * tc,
            observaciones: obsEdit || "NA",
          },
          { headers }
        );
    request
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Editar Pago", detalle: `${numeroEdit}`, user: user.id },
          { headers }
        );
        toggleEdit();
        Swal.fire("¡Listo!", "Pago actualizado", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data || ""}`,
        });
        console.log(error);
      });
  }

  function cancelarPago(id, numero, proveedor, esReferencia) {
    Swal.fire({
      title: esReferencia ? "¿Cancelar este anticipo?" : "¿Cancelar este pago?",
      text: `${numero} - ${proveedor}. Se revertirán los ajustes de saldo.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, cancelar",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        const headers = {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        };
        // Anticipo -> cancel de anticipos (GET); Pago -> cancel de pagos (PATCH)
        const request = esReferencia
          ? axios.get(`${URL_ANTICIPOS_PROVEEDORES}Cancel/${id}`, { headers })
          : axios.patch(`${URL_PAGOS_PROVEEDORES}Cancel/${id}`, {}, { headers });
        request
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Cancelar Pago",
                detalle: `${numero} - ${proveedor}`,
                user: user.id,
              },
              { headers }
            );
            // Lo quita de la vista sin refrescar
            setComments((prev) => prev.filter((c) => c._id !== id));
            Swal.fire("¡Listo!", "Pago cancelado", "success");
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error?.response?.data || ""}`,
            });
            console.log(error);
          });
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.pagoProveedores ? (
                <Button title="Registrar un pago a proveedor"
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/PagosProveedoresCreate"
                >
                  Nuevo Pago
                </Button>
              ) : (
                <span title="No tienes permiso para registrar pagos">
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                  style={{ pointerEvents: "none" }}
                >
                  Nuevo Pago
                </Button>
                </span>
              )}
              <Button title="Regresar al menu"
                size="sm"
                href="/MenuCXP"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button title="Descargar el listado en PDF"
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button title="Mandar el listado por correo"
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button title="Descargar el listado en Excel"
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Pagos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button title="Mandar el correo" size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte de Pagos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Validado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedValidado}
                onChange={(e) => {
                  setSelectedValidado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Si">Validados</option>
                <option value="No">No validados</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Estado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEstado}
                onChange={(e) => {
                  setSelectedEstado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Pagado">Pagados</option>
                <option value="Simulado">Simulados</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Concepto</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedConcepto}
                onChange={(e) => {
                  setSelectedConcepto(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                {[...new Set(comments.map((c) => c.concepto).filter(Boolean))]
                  .sort()
                  .map((c) => (
                    <option value={c}>{c}</option>
                  ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                {proveedores
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => (
                    <option value={a._id}>
                      {a.codigo} - {a.nombre_comercial}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr
                      style={
                        a.esReferencia ? { backgroundColor: "#eff6ff" } : {}
                      }
                    >
                      <td>{a.numero}</td>
                      <td style={{ minWidth: 100 }}>{a.fecha}</td>
                      <td>{a.proveedores}</td>
                      <td style={{ minWidth: 120 }}>
                        {a.ordenesCompraAplicadas && a.ordenesCompraAplicadas.length ? (
                          a.ordenesCompraAplicadas.map((x, i) => (
                            <div key={i} style={{ fontSize: 12 }} title={x.observaciones}>
                              OC {x.numero} ·{" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                              }).format(Number(x.monto) || 0)}
                            </div>
                          ))
                        ) : (
                          <span>{a.odc}</span>
                        )}
                        {!a.esReferencia ? (
                          <Button title="Un solo comprobante para varias OC: repartir el monto entre ellas"
                            size="sm"
                            color="link"
                            style={{ padding: 0, fontSize: 11 }}
                            onClick={() => abreOrdenes(a)}
                          >
                            Repartir en varias OC
                          </Button>
                        ) : null}
                      </td>
                      <td>{a.embarque}</td>
                      <td>{a.concepto}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.montoUSD)}</td>
                      <td>{Number(a.tipoCambio).toFixed(2)}</td>
                      <td>{new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN", maximumFractionDigits: 2}).format(a.totalMXN)}</td>
                      <td>
                        {a.estado === "Pagado" ? (
                          <Badge color="primary" pill>
                            Pagado
                          </Badge>
                        ) : (
                          <Badge color="secondary" pill>
                            Simulado
                          </Badge>
                        )}
                      </td>
                      <td>
                        {a.validado === "Si" ? (
                          <Badge color="success" pill>
                            Validado
                          </Badge>
                        ) : (
                          <Badge color="warning" pill>
                            Pendiente
                          </Badge>
                        )}
                      </td>
                      <td>
                        {a.archivos && a.archivos.length ? (
                          a.archivos.map((f, i) => (
                            <a
                              key={f.public_id || i}
                              href={f.url}
                              target="_blank"
                              rel="noreferrer"
                              title={f.nombre}
                              className="btn btn-info btn-sm"
                              style={{ marginRight: 4 }}
                            >
                              <i class="fas fa-paperclip"></i>
                              {a.archivos.length > 1 ? ` ${i + 1}` : ""}
                            </a>
                          ))
                        ) : (
                          <span style={{ fontSize: 11, color: "#94a3b8" }}>—</span>
                        )}
                      </td>
                      <td style={{ minWidth: 150 }}>
                        {a.dineroRecibido === "Si" ? (
                          <Badge
                            color="success"
                            pill
                            title={`Confirmado el ${a.fechaDineroRecibido} por ${a.dineroRecibidoPor || "—"}`}
                          >
                            Recibido
                          </Badge>
                        ) : (
                          <Badge color="warning" pill>
                            Pendiente
                          </Badge>
                        )}{" "}
                        {user.pagos_recepcion && !a.esReferencia ? (
                          <Button
                            size="sm"
                            className="btn"
                            color={a.dineroRecibido === "Si" ? "secondary" : "info"}
                            title={
                              a.dineroRecibido === "Si"
                                ? "Quitar la confirmacion de recepcion"
                                : "Confirmar que el proveedor recibio el dinero"
                            }
                            onClick={() => confirmaDineroRecibido(a)}
                          >
                            <i class="fas fa-hand-holding-usd"></i>
                          </Button>
                        ) : null}
                      </td>
                      <td style={{ minWidth: 220 }}>
                            {a.validado === "Si" ? (
                              user.pagos_validar ? (
                                <Button title="Quitar la validacion del pago"
                                  size="sm"
                                  className="btn"
                                  color="warning"
                                  onClick={() =>
                                    desvalidarPago(
                                      a._id,
                                      a.numero,
                                      a.proveedores,
                                      a.esReferencia
                                    )
                                  }
                                >
                                  <i class="fas fa-undo"></i> Quitar validación
                                </Button>
                              ) : null
                            ) : (
                              <>
                                {/* Toggle Simulado/Pagado (solo pagos, no anticipos) */}
                                {user.pagos_marcar && !a.esReferencia && a.estado !== "Pagado" ? (
                                  <Button title="Marcar el pago como Pagado (ya salio el dinero)"
                                    size="sm"
                                    className="btn"
                                    color="primary"
                                    onClick={() =>
                                      marcarPagado(a._id, a.numero, a.proveedores)
                                    }
                                  >
                                    <i class="fas fa-money-check"></i> Marcar pagado
                                  </Button>
                                ) : null}{" "}
                                {user.pagos_marcar && !a.esReferencia && a.estado === "Pagado" ? (
                                  <Button title="Regresar el pago a Simulado (no afecta saldos)"
                                    size="sm"
                                    className="btn"
                                    color="secondary"
                                    onClick={() =>
                                      marcarSimulado(a._id, a.numero, a.proveedores)
                                    }
                                  >
                                    <i class="fas fa-undo"></i> Simular
                                  </Button>
                                ) : null}{" "}
                                {/* Validar: solo si ya está Pagado */}
                                {user.pagos_validar && a.estado === "Pagado" ? (
                                  <Button title="Validar el pago"
                                    size="sm"
                                    className="btn"
                                    color="success"
                                    onClick={() =>
                                      validarPago(
                                        a._id,
                                        a.numero,
                                        a.proveedores,
                                        a.esReferencia
                                      )
                                    }
                                  >
                                    <i class="fas fa-check"></i> Validar
                                  </Button>
                                ) : null}{" "}
                                {/* Editar/Cancelar para pagos y anticipos (cada uno a su endpoint) */}
                                <Button title="Editar el pago"
                                  size="sm"
                                  className="btn"
                                  color="info"
                                  onClick={() => abrirEditar(a)}
                                >
                                  <i class="far fa-edit"></i>
                                </Button>{" "}
                                {user.pagos_cancelar ? (
                                  <Button title="Cancelar el pago"
                                    size="sm"
                                    className="btn"
                                    color="danger"
                                    onClick={() =>
                                      cancelarPago(
                                        a._id,
                                        a.numero,
                                        a.proveedores,
                                        a.esReferencia
                                      )
                                    }
                                  >
                                    <i class="fas fa-ban"></i>
                                  </Button>
                                ) : null}
                              </>
                            )}
                      </td>

                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr style={{ fontWeight: 700, borderTop: "2px solid #cbd5e1" }}>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="text-right">Totales</td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(
                    commentsData.reduce(
                      (acc, r) => acc + (Number(r.montoUSD) || 0),
                      0
                    )
                  )}
                </td>
                <td></td>
                <td>
                  {new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    maximumFractionDigits: 2,
                  }).format(
                    commentsData.reduce(
                      (acc, r) => acc + (Number(r.totalMXN) || 0),
                      0
                    )
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="md" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Pago {numeroEdit}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={guardarEdit}>
            <Row>
              <Col md={6}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  value={fechaEdit}
                  required
                  onChange={(e) => setFechaEdit(e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Label>Concepto</Label>
                {esRefEdit ? (
                  <Input type="text" value="ANTICIPO" disabled />
                ) : (
                  <Input
                    type="select"
                    value={conceptoEdit}
                    onChange={(e) => setConceptoEdit(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {conceptosCat
                      .sort((a, b) => (a.concepto > b.concepto ? 1 : -1))
                      .map((c) => (
                        <option value={c._id}>{c.concepto}</option>
                      ))}
                  </Input>
                )}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={4}>
                <Label>Monto USD</Label>
                <Input
                  type="number"
                  step="any"
                  value={montoEdit}
                  required
                  onChange={(e) => setMontoEdit(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Label>TDC</Label>
                <Input
                  type="number"
                  step="any"
                  min="0"
                  value={tcEdit}
                  onChange={(e) => setTcEdit(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Label>Total MXN</Label>
                <Input
                  type="text"
                  disabled
                  value={new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                  }).format((Number(montoEdit) || 0) * (Number(tcEdit) || 1))}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  value={obsEdit}
                  onChange={(e) => setObsEdit(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Button title="Guardar los cambios del pago" type="submit" className="btn btn-success">
              Guardar
            </Button>
          </Form>
        </ModalBody>
      </Modal>

      {/* Un comprobante que cubre varias OC */}
      <Modal size="lg" isOpen={modalOrdenes} toggle={toggleOrdenes}>
        <ModalHeader toggle={toggleOrdenes}>
          <h4>Repartir el pago {pagoOrdenes.numero} entre varias OC</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ fontSize: 12, color: "#64748b" }}>
            {pagoOrdenes.proveedores} ·{" "}
            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
              Number(pagoOrdenes.montoUSD) || 0
            )}{" "}
            pagados
          </div>
          <br />
          <Table size="sm" borderless>
            <thead>
              <tr>
                <th style={{ fontSize: 12 }}>Orden de compra</th>
                <th style={{ fontSize: 12, width: 130 }}>Monto USD</th>
                <th style={{ fontSize: 12 }}>Observaciones</th>
                <th style={{ width: 40 }}></th>
              </tr>
            </thead>
            <tbody>
              {repartoOC.map((r, index) => (
                <tr key={index}>
                  <td>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={r.ordenesCompra}
                      onChange={(e) => {
                        const oc = catalogoOC.find((o) => o._id === e.target.value);
                        setRepartoOC((prev) =>
                          prev.map((x, i) =>
                            i === index
                              ? { ...x, ordenesCompra: e.target.value, numero: oc?.idOrdenCompra || "" }
                              : x
                          )
                        );
                      }}
                    >
                      <option value="">Selecciona</option>
                      {catalogoOC.map((o) => (
                        <option key={o._id} value={o._id}>
                          OC {o.idOrdenCompra} · {o.fecha} ·{" "}
                          {new Intl.NumberFormat("en-US").format(o.total_general || 0)} {o.moneda}
                        </option>
                      ))}
                    </Input>
                  </td>
                  <td>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      step="any"
                      value={r.monto}
                      onChange={(e) =>
                        setRepartoOC((prev) =>
                          prev.map((x, i) => (i === index ? { ...x, monto: e.target.value } : x))
                        )
                      }
                    />
                  </td>
                  <td>
                    <Input
                      bsSize="sm"
                      type="text"
                      value={r.observaciones}
                      onChange={(e) =>
                        setRepartoOC((prev) =>
                          prev.map((x, i) =>
                            i === index ? { ...x, observaciones: e.target.value } : x
                          )
                        )
                      }
                    />
                  </td>
                  <td>
                    <Button title="Quitar esta orden del reparto"
                      size="sm"
                      color="danger"
                      onClick={() => setRepartoOC((prev) => prev.filter((x, i) => i !== index))}
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Button title="Agregar otra orden al reparto"
            size="sm"
            color="info"
            onClick={() =>
              setRepartoOC((prev) => [
                ...prev,
                { ordenesCompra: "", numero: "", monto: 0, observaciones: "" },
              ])
            }
          >
            <i class="fas fa-plus"></i> Agregar orden
          </Button>
          <div
            style={{
              marginTop: 14,
              fontSize: 13,
              fontWeight: 600,
              color:
                sumaReparto > Number(pagoOrdenes.montoUSD || 0) + 0.01 ? "#b91c1c" : "#15803d",
            }}
          >
            Repartido{" "}
            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
              sumaReparto
            )}{" "}
            de{" "}
            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
              Number(pagoOrdenes.montoUSD) || 0
            )}
            {sumaReparto > Number(pagoOrdenes.montoUSD || 0) + 0.01
              ? " · se pasa del total pagado"
              : ""}
          </div>
          <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
            El total pagado no cambia: esto solo dice a que ordenes corresponde.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button title="Guardar el reparto entre ordenes" color="success" onClick={guardaReparto}>
            Guardar
          </Button>
          <Button title="Cerrar sin guardar" color="secondary" onClick={toggleOrdenes}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>


      {loader}
    </>
  );
}

export default ListadoPagosProveedores;
